import React, { useContext, useState } from 'react';
import { Query } from 'react-apollo';
import NewGroupModal from '../../../components/NewGroupModal';
import AddToNotebookModal from '../../../components/settings/NotebookMemberList/AddToNotebookModal';
import { ButtonFilled, Card } from '../../../components/ui';
import { NotebookContext } from '../../../context/NotebookContext';
import { notebookMembersQuery } from '../../../queries/notebooks';
import {
  NotebookMembersQuery,
  NotebookMembersQueryVariables
} from '../../../queries/__generated__/NotebookMembersQuery';
import NewSubjectModal from '../../../components/NewSubjectModal';

const EmptyState = () => {
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showNewSubjectModal, setShowNewSubjectModal] = useState(false);
  const [showNewGroupModal, setShowNewGroupModal] = useState(false);
  const { notebook } = useContext(NotebookContext);

  return (
    <div className="flex-auto flex items-center justify-center mb5" data-testid="feed-empty-state">
      <div className="pv2 pv4-ns w-100" style={{ maxWidth: 702 }}>
        <Card className="tc center mb2" data-testid="new-tracker-card">
          <div className="pa4">
            <h2 className="f5 fw6 mv2">Create a Subject</h2>
            <p className="f7 serif lh-copy measure mt0 mb3 center">
              A Subject is one of your team’s shared concerns, like a client, customer, product, or
              project.
            </p>
            <button
              onClick={() => setShowNewSubjectModal(true)}
              data-testid="new-subject-button"
              className="f6 blue hover-navy mb2"
            >
              New Subject
            </button>
          </div>
        </Card>

        {showNewGroupModal && <NewGroupModal closeModal={() => setShowNewGroupModal(false)} />}
        {showNewSubjectModal && (
          <NewSubjectModal closeModal={() => setShowNewSubjectModal(false)} redirectToSubject />
        )}
        {showInviteModal && (
          <Query<NotebookMembersQuery, NotebookMembersQueryVariables>
            query={notebookMembersQuery}
            variables={{ input: { notebookId: notebook.id } }}
          >
            {({ data, loading, error }) => {
              if (loading) {
                return <div />;
              }
              const notebookMembers = data!.notebookMembers;
              return (
                <AddToNotebookModal
                  closeModal={() => setShowInviteModal(false)}
                  notebookMembers={notebookMembers}
                />
              );
            }}
          </Query>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
